import React from 'react';
import { WordData, PileData } from '../types/game';
import WordCard from './WordCard';

interface TableauPileProps {
  pile: PileData; 
  allWordData: Map<string, WordData>; 
  onCardMoveStart: (word: string, sourcePileId: number) => void; 
  onCardDrop: (draggedWord: string, targetPileId: number) => void; // 放置回调
  onCardClick?: (word: string, sourcePileId: number) => void; // 点击回调
  onAddToVocab: (wordData: WordData) => void;
}

const TableauPile: React.FC<TableauPileProps> = ({ 
    pile, 
    allWordData, 
    onCardMoveStart, 
    onCardDrop,
    onCardClick,
    onAddToVocab 
}) => {
  
  const handleDragStartInPile = (word: string) => {
      onCardMoveStart(word, pile.pileId); 
  };

  const handleCardClickInPile = (word: string) => {
      if (onCardClick) {
          onCardClick(word, pile.pileId);
      }
  };
  
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault(); // 允许放置
    // 可选：根据规则改变拖拽光标或目标桩的视觉效果
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const draggedWord = e.dataTransfer.getData("text/plain");
    
    // 统一将所有拖拽事件传递给 GameContainer 处理
    // 让 GameContainer 负责验证逻辑和显示 toast
    onCardDrop(draggedWord, pile.pileId);
  };

  return (
    <div 
      className="tableau-pile-container"
      onDrop={handleDrop} // 放置事件
      onDragOver={handleDragOver} // 拖拽悬停事件
    >
      {pile.cards.length === 0 ? (
        // 确保空桩占位符也能够触发放置事件
        <div className="empty-pile-placeholder" onDrop={handleDrop} onDragOver={handleDragOver}>
            <p className="drop-text">Drop Here</p>
        </div>
      ) : (
          // 使用递归方式渲染卡片堆叠，实现拖拽时连带移动
          (function renderCards(index: number): React.ReactNode {
              if (index >= pile.cards.length) return null;
              const card = pile.cards[index];
              const wordData = allWordData.get(card.word);
              if (!wordData) return null;

              const isDraggable = card.isFaceUp;

              return (
                  <WordCard
                    key={card.word}
                    data={wordData}
                    isDraggable={isDraggable}
                    isFaceUp={card.isFaceUp}
                    stackIndex={index}
                    overlapOffset={index === 0 ? 0 : 25} // 第一张偏移为0，后续嵌套偏移25
                    onDragStart={handleDragStartInPile}
                    onCardClick={handleCardClickInPile}
                    onAddToVocab={onAddToVocab}
                  >
                      {renderCards(index + 1)}
                  </WordCard>
              );
          })(0)
      )}
    </div>
  );
};

export default TableauPile;
